import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from 'src/app/shared/AppSettings';
import { ItemCateSalesPieChartModel } from 'src/app/models/charts/ItemCateSalesPieChartModel';
import { shareReplay } from 'rxjs/operators';





@Injectable({
    providedIn: 'root'
})

export class CustomReportService {

    constructor(private http: HttpClient) { }
    baseurl: string = AppSettings.BaseURI;

    readonly pathName = '/CustomReport';

    GetCustomReport(reportID:number, data: any) {
        return this.http.post<Blob>(this.baseurl + this.pathName + "/"+reportID,data, { responseType: 'blob' as 'json' });
    }

    getAnalysisReportData(shopID: string,caseID: number,searchDate:string,endDate:string ,data:any) {
        return this.http.post<any>(this.baseurl + this.pathName
             + '/GetAnalysisReportData/' + shopID+'/'+caseID+'/'+searchDate+'/'+endDate,data).pipe(shareReplay(1));
    }

}